export default __webpack_public_path__ + "images/e2903d216eb2f994ebb2121f40043035-fashion.webp";